import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import StudentWidget from './student-widget';
import CommonValues from 'resources/common-values';

export default CreateReactClass({
    displayName: 'batch-print-students',

    PropTypes: {
        selectStudents: PropTypes.func.isRequired,
        selectFormat: PropTypes.func.isRequired,
        students: PropTypes.instanceOf(Immutable.List).isRequired,
        onSelectStudents: PropTypes.func.isRequired,
        selectedStudentForPrinting: PropTypes.oneOf(['previous', 'current', 'next']).isRequired,
        toggleStudentSelection: PropTypes.func.isRequired,
        togglePrintFormat: PropTypes.func.isRequired,
        selectedPrintFormat: PropTypes.instanceOf(Immutable.Set).isRequired,
        studentPreviousSelection: PropTypes.oneOf(['previous', 'current', 'next']).isRequired,
        selectedStudents: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectedStudentBids: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectedStudentsFromList: PropTypes.instanceOf(Immutable.Set).isRequired,
        studentsChanged: PropTypes.bool.isRequired,
        togglePrintAndShare: PropTypes.func.isRequired,
        batchOptionState: PropTypes.bool.isRequired,
        createPdfAction: PropTypes.func.isRequired,
        isSingleStudentMode: PropTypes.bool.isRequired,
    },

    render() {
        const selectedStudents =
            this.props.selectedStudentForPrinting == 'all'
                ? this.props.students.size
                : this.props.selectedStudentForPrinting == 'choose' && !this.props.studentsChanged
                ? this.props.students.size
                : this.props.selectedStudentForPrinting == 'choose' && this.props.selectedStudentsFromList != undefined
                ? this.props.selectedStudentsFromList.size
                : null;

        const verifyStudentSelection =
            selectedStudents > CommonValues.MAX_STUDENTS_FOR_BATCH_PRINT ||
            (this.props.selectedStudentForPrinting == 'choose' &&
                this.props.studentsChanged &&
                (this.props.selectedStudentsFromList == undefined || this.props.selectedStudentsFromList.size == 0));

        const tooltipMessage =
            selectedStudents > CommonValues.MAX_STUDENTS_FOR_BATCH_PRINT
                ? `Batch PDFs cannot include more than ${CommonValues.MAX_STUDENTS_FOR_BATCH_PRINT} students`
                : 'No student selected';

        const containerClass = 'button-container' + (verifyStudentSelection ? ' show-tooltip' : '');
        const disabledRadioInput = this.props.isSingleStudentMode ? { disabled: 'disabled' } : {};
        const tooltip = <div className="tooltip">{tooltipMessage}</div>;
        const arrow = <div className="tooltip arrow" />;

        return (
            <div className="students options-container">
                <div>
                    <h4>SELECT STUDENTS</h4>
                    {this.props.isFamilyReportURL ? null : (
                        <div className="batch-option">
                            <input
                                type="radio"
                                id="print-current-student-option"
                                checked={this.props.selectedStudentForPrinting == 'current'}
                                onChange={(event) => this.props.toggleStudentSelection(event, 'current')}
                            />
                            <label htmlFor="print-current-student-option">Only this student</label>
                        </div>
                    )}
                    <div className="batch-option all-students-option">
                        <input
                            type="radio"
                            {...disabledRadioInput}
                            id="print-all-students-option"
                            data-testid="print-all-students-option"
                            checked={this.props.selectedStudentForPrinting == 'all'}
                            onChange={(event) => this.props.toggleStudentSelection(event, 'all')}
                        />
                        <label htmlFor="print-all-students-option">All students in this class</label>
                        <div className="group-by">
                            <div className="batch-option">
                                <input
                                    type="checkbox"
                                    id="print-pages-without-test-option"
                                    data-testid="print-pages-without-test-option"
                                    checked={this.props.selectedPrintFormat.includes('no test')}
                                    onChange={(event) => this.props.togglePrintFormat(event, 'no test')}
                                />
                                <label htmlFor="print-pages-without-test-option">
                                    Include students and subjects without test results in the selected term (Not common)
                                </label>
                            </div>
                            <div className="batch-option">
                                <input
                                    type="checkbox"
                                    id="print-pages-two-sides-option"
                                    checked={this.props.selectedPrintFormat.includes('page break')}
                                    onChange={(event) => this.props.togglePrintFormat(event, 'page break')}
                                />
                                <label htmlFor="print-pages-two-sides-option">
                                    Include page breaks for 2-sided printing (Recommended. Prevents two students from
                                    being printed on the same page.)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="batch-option select-students-option">
                        <input
                            type="radio"
                            {...disabledRadioInput}
                            id="print-selected-students-option"
                            data-testid="print-selected-students-option"
                            checked={this.props.selectedStudentForPrinting == 'choose'}
                            onChange={(event) => this.props.toggleStudentSelection(event, 'choose')}
                        />
                        <label htmlFor="print-selected-students-option">Select students in this class</label>
                        <div className="group-by">
                            <div className="batch-option">
                                <input
                                    type="checkbox"
                                    id="selected-students-print-pages-without-test-option"
                                    checked={this.props.selectedPrintFormat.includes('no test selected students')}
                                    onChange={(event) =>
                                        this.props.togglePrintFormat(event, 'no test selected students')
                                    }
                                />
                                <label htmlFor="selected-students-print-pages-without-test-option">
                                    Include students and subjects without test results in the selected term (Not common)
                                </label>
                            </div>
                            <div className="batch-option">
                                <input
                                    type="checkbox"
                                    id="selected-students-print-pages-two-sides-option"
                                    checked={this.props.selectedPrintFormat.includes('page break selected students')}
                                    onChange={(event) =>
                                        this.props.togglePrintFormat(event, 'page break selected students')
                                    }
                                />
                                <label htmlFor="selected-students-print-pages-two-sides-option">
                                    Include page breaks for 2-sided printing (Recommended. Prevents two students from
                                    being printed on the same page.)
                                </label>
                            </div>
                            <StudentWidget
                                students={this.props.students}
                                disabled={false}
                                onSelectStudents={this.props.onSelectStudents}
                                selectedStudents={this.props.selectedStudents}
                                selectedStudentBids={this.props.selectedStudentBids}
                                setClearSelectedStudents={this.props.setClearSelectedStudents}
                                batchOptionState={this.props.batchOptionState}
                            />
                        </div>
                    </div>
                </div>
                <div className={containerClass}>
                    <button
                        className="button-next print-reports"
                        onClick={(event) => this.props.createPdfAction(event)}
                        disabled={!!verifyStudentSelection}
                    >
                        CREATE PDF REPORT
                    </button>
                    {tooltip}
                    {arrow}
                </div>
            </div>
        );
    },
});
